import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import styled from "styled-components";
import { colors } from "../../styles/colors";
import { MenuItem } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";

const DropdownToggle = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5px 0px;
  height: 25px;
  border-bottom: 1px solid ${colors.orange};
  cursor: ${({ enabled }) => (enabled ? "pointer" : "default")};
  &:hover {
    background-color: ${({ enabled }) =>
      enabled ? "#00000010" : "transparent"};
  }
`;

const DropdownLabel = styled.div`
  cursor: ${({ enabled }) => (enabled ? "pointer" : "default")};
  opacity: ${({ enabled }) => (enabled ? 1 : 0.5)};
`;

const Select = ({
  title,
  data,
  children,
  onChange,
  enabled = true,
}: {
  title?: string;
  data?: {
    label: string;
    value: any;
  }[];
  children?: any;
  onChange?: (v: any) => void;
  enabled?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  return (
    <>
      <DropdownToggle
        enabled={enabled}
        onClick={(e) => {
          enabled && setAnchorEl(e.currentTarget);
        }}
      >
        <DropdownLabel enabled={enabled}>{title}</DropdownLabel>
        <FontAwesomeIcon color={colors.white} icon={faSortDown} />
      </DropdownToggle>
      <Menu
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorEl={anchorEl}
        PaperProps={{
          style: {
            maxHeight: 450,
          },
        }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          horizontal: "center",
          vertical: "center",
        }}
        getContentAnchorEl={undefined}
      >
        {children}
        {data &&
          data.map((datum, i) => {
            return (
              <MenuItem
                onClick={(e) => {
                  const val = e.currentTarget.dataset.val;
                  if (val) {
                    onChange(val);
                    setAnchorEl(null);
                  }
                }}
                key={i}
                data-val={datum.value}
              >
                {datum.label}
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
};

export default Select;
